<template>
  <div id="navigation-menu" :class="{ 'nav-active': open }">
    <header class="cd-header">
      <div class="logo-wrap">
        <router-link to="/" tag="a"
          ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 449.98 111.13">
            <g>
              <path
                class="logomark"
                d="M62.55,19.62v69.2h3.67V19.62Zm0,0v69.2h3.67V19.62ZM0,0V108.9H115V0ZM34.74,94.77a3.63,3.63,0,0,1-3.63,3.64H13.91a3.63,3.63,0,0,1-3.62-3.64V79.6H21v9.22h3.09V76.52l-10.62,0H10.29V13.67A3.62,3.62,0,0,1,13.91,10h17.2a3.62,3.62,0,0,1,3.63,3.63V26.88H24.06V19.62H21V69.3H34.74ZM48.91,98.9H38.23V49H34.74V66.25H24.06V29.93H34.74v9.51h3.49V10H48.91Zm27.9-4.13a3.62,3.62,0,0,1-3.6,3.64H55.56A3.62,3.62,0,0,1,52,94.77V13.67A3.61,3.61,0,0,1,55.56,10H73.21a3.61,3.61,0,0,1,3.6,3.63Zm27.9-34.62-3.21.94,3.21,1V98.41H94.46V65.88H90.1V98.41H79.86V62.05l3.21-1-3.21-.94V10H90.1V56.28h4.36V10h10.25ZM62.55,88.82h3.67V19.62H62.55Z"
              />
              <path
                d="M381,62.06l-8.64-12.59-5,7.44,12.08,18.41h10.69Zm8.07-50.33H378.84l-11,16.6,4.84,7.24ZM355.9,44.39l1.17-1.66-21.35-31H346.5L362.1,35.1s.63,1,.64.94l4.6,6.69L347.63,71l-2.95,4.37H334.3Z"
              />
              <path
                d="M173.21,54.8a17.36,17.36,0,0,0,2.56,8.79q4.28,6.33,15.11,6.32a26.86,26.86,0,0,0,8.83-1.38q7.69-2.69,7.7-9.61c0-3.47-1.08-5.93-3.24-7.4s-5.63-2.7-10.31-3.77l-8.61-2q-8.44-1.9-11.95-4.2-6.06-4-6.06-11.9a18.33,18.33,0,0,1,5.93-14.07q5.93-5.51,16.8-5.5,10,0,17,4.83t7,15.43h-8.1a15.86,15.86,0,0,0-2.77-7.84q-3.93-5-13.37-5-7.62,0-11,3.2a10,10,0,0,0-3.33,7.44,7.26,7.26,0,0,0,3.9,6.84q2.55,1.39,11.56,3.47l8.91,2a27.38,27.38,0,0,1,10,4q6.06,4.45,6.06,12.94,0,10.56-7.68,15.11a34.45,34.45,0,0,1-17.86,4.55q-11.86,0-18.57-6.06T165.12,54.8Z"
              />
              <path
                d="M220.11,11.73h8.7V38h33.07V11.73h8.71V75.32h-8.71V45.58H228.81V75.32h-8.7Z"
              />
              <path
                d="M329.47,20.82q6.33,8.45,6.32,21.6,0,14.25-7.23,23.68-8.47,11.09-24.19,11.09-14.69,0-23.08-9.7-7.49-9.34-7.49-23.64,0-12.9,6.41-22.08Q288.43,10,304.54,10,321.39,10,329.47,20.82Zm-7.59,40.5A34.73,34.73,0,0,0,327,42.55q0-11.2-5.86-18t-16-6.84A20.9,20.9,0,0,0,289,24.44q-6.22,6.76-6.23,20,0,10.56,5.35,17.81t17.33,7.25Q316.79,69.48,321.88,61.32Z"
              />
              <path
                d="M175.87,82.29h1.88l4.45,12.25h-1.82l-1.25-3.67h-4.84L173,94.54h-1.7Zm2.73,7.23-1.86-5.41-2,5.41Z"
              />
              <path
                d="M202.15,82.29h5A4.7,4.7,0,0,1,211,84.08a6.61,6.61,0,0,1,1.24,4.15,8.41,8.41,0,0,1-.73,3.53,4.55,4.55,0,0,1-4.45,2.78h-4.95Zm4.63,10.83a4.5,4.5,0,0,0,1.39-.17,3,3,0,0,0,1.58-1.25,5.06,5.06,0,0,0,.71-1.9,7.72,7.72,0,0,0,.13-1.29,6,6,0,0,0-.91-3.53,3.33,3.33,0,0,0-2.91-1.26h-3v9.4Z"
              />
              <path
                d="M242.88,84a6.78,6.78,0,0,1,1.22,4.16,7.32,7.32,0,0,1-1.4,4.57,6.18,6.18,0,0,1-9.1.26,7.06,7.06,0,0,1-1.44-4.55,7.22,7.22,0,0,1,1.23-4.25A5.34,5.34,0,0,1,238.08,82,5.6,5.6,0,0,1,242.88,84Zm-1.46,7.8a6.69,6.69,0,0,0,1-3.61,5.18,5.18,0,0,0-1.13-3.48,3.87,3.87,0,0,0-3.09-1.32,4,4,0,0,0-3.11,1.31,5.5,5.5,0,0,0-1.2,3.85,5.67,5.67,0,0,0,1,3.43,3.88,3.88,0,0,0,3.34,1.4A3.47,3.47,0,0,0,241.42,91.84Z"
              />
              <path
                d="M264.41,82.29h2.37l3.52,10.36,3.5-10.36h2.35V94.54h-1.58V87.31c0-.25,0-.66,0-1.24s0-1.2,0-1.86l-3.5,10.33h-1.64L266,84.21v.37c0,.3,0,.76,0,1.38s0,1.06,0,1.35v7.23h-1.58Z"
              />
              <path
                d="M307.14,84a6.78,6.78,0,0,1,1.22,4.16A7.31,7.31,0,0,1,307,92.77a6.19,6.19,0,0,1-9.11.26,7.06,7.06,0,0,1-1.44-4.55,7.22,7.22,0,0,1,1.23-4.25A5.34,5.34,0,0,1,302.34,82,5.6,5.6,0,0,1,307.14,84Zm-1.46,7.8a6.69,6.69,0,0,0,1-3.61,5.18,5.18,0,0,0-1.13-3.48,3.84,3.84,0,0,0-3.09-1.32,4,4,0,0,0-3.1,1.31,5.5,5.5,0,0,0-1.2,3.85,5.61,5.61,0,0,0,1,3.43,3.87,3.87,0,0,0,3.34,1.4A3.45,3.45,0,0,0,305.68,91.84Z"
              />
              <path
                d="M328.71,82.29h1.62v6l6-6h2.29l-5.09,4.94,5.24,7.31h-2.16l-4.29-6.14-2,1.87v4.27h-1.62Z"
              />
              <path
                d="M362,82.29h1.88l4.44,12.25h-1.82l-1.24-3.67h-4.84l-1.33,3.67h-1.7Zm2.73,7.23-1.86-5.41-2,5.41Z"
              />
              <path d="M388.62,82.29h1.68V94.54h-1.68Z" />
            </g>
          </svg>
        </router-link>
      </div>
      <button
        v-if="supportsMessaging"
        :title="
          notificationStatus
            ? 'unsubscribe from push notifications'
            : 'subscribe to push notifications'
        "
        @click="setNotificationStatus"
        :disabled="disabled"
        :style="{ opacity: disabled ? '0' : '1' }"
        class="btn push-notification"
        :class="{ active: notificationStatus }"
      >
        <svg width="50pt" height="50pt" viewBox="0 0 50 50" version="1.1">
          <path
            v-if="notificationStatus"
            d="M 25 0 C 22.792969 0 21 1.792969 21 4 C 21 6.207031 22.792969 8 25 8 C 27.207031 8 29 6.207031 29 4 C 29 1.792969 27.207031 0 25 0 Z M 19.375 6.09375 C 14.804688 8.050781 12 12.457031 12 18 C 12 29 8.199219 31.761719 5.9375 33.40625 C 4.933594 34.132813 4 34.808594 4 36 C 4 40.207031 10.28125 42 25 42 C 39.71875 42 46 40.207031 46 36 C 46 34.808594 45.066406 34.132813 44.0625 33.40625 C 41.800781 31.761719 38 29 38 18 C 38 12.441406 35.199219 8.046875 30.625 6.09375 C 29.769531 8.367188 27.566406 10 25 10 C 22.433594 10 20.230469 8.363281 19.375 6.09375 Z M 19 43.875 C 19 43.914063 19 43.960938 19 44 C 19 47.308594 21.691406 50 25 50 C 28.308594 50 31 47.308594 31 44 C 31 43.960938 31 43.914063 31 43.875 C 29.117188 43.953125 27.117188 44 25 44 C 22.882813 44 20.882813 43.953125 19 43.875 Z "
          />
          <path
            v-else
            d="M 25 3.125 C 23.289063 3.125 21.875 4.539063 21.875 6.25 L 21.875 9.800781 C 20.519531 10.15625 19.25 10.71875 18.117188 11.472656 L 37.5 30.859375 L 37.5 21.875 C 37.5 16.0625 33.496094 11.21875 28.125 9.8125 L 28.125 6.25 C 28.125 4.539063 26.707031 3.125 25 3.125 Z M 8.519531 6.324219 L 6.324219 8.519531 L 13.964844 16.175781 C 13.0625 17.882813 12.5 19.800781 12.5 21.875 L 12.5 34.324219 C 12.488281 34.65625 12.328125 37.5 9.375 37.5 L 9.375 40.625 L 38.414063 40.625 L 41.46875 43.6875 L 43.6875 41.46875 L 40.625 38.414063 L 40.625 38.402344 L 39.597656 37.367188 C 39.585938 37.367188 39.574219 37.351563 39.5625 37.351563 L 37.660156 35.449219 C 37.660156 35.449219 37.660156 35.4375 37.660156 35.4375 L 15.757813 13.523438 C 15.757813 13.539063 15.757813 13.539063 15.746094 13.550781 Z M 25 40.625 C 23.277344 40.625 21.875 42.027344 21.875 43.75 C 21.875 45.472656 23.277344 46.875 25 46.875 C 26.722656 46.875 28.125 45.472656 28.125 43.75 C 28.125 42.027344 26.722656 40.625 25 40.625 Z "
          />
        </svg>
      </button>
      <div class="navbar-wrap">
        <a class="menu-icon " @click="open = !open">
          <span class="menu-icon__line menu-icon__line-left"></span>
          <span class="menu-icon__line"></span>
          <span class="menu-icon__line menu-icon__line-right"></span>
        </a>
      </div>
    </header>

    <nav class="nav">
      <div class="nav__content">
        <div class="curent-page-name-shadow">
          {{ this.$route.name }}
        </div>
        <ul class="nav__list" @click="open = false">
          <router-link tag="li" to="/" class="nav__list-item">
            <a href="#">home</a>
          </router-link>
          <router-link tag="li" to="/about" class="nav__list-item">
            <a href="#">about</a>
          </router-link>
          <router-link tag="li" to="/projects" class="nav__list-item">
            <a href="#">projects</a>
            <ul v-if="$route.meta.showSubMenu" class="sub-links">
              <router-link tag="li" to="/projects/designs">
                <a href="#">designs</a>
              </router-link>
              <router-link tag="li" to="/projects/websites">
                <a href="#">websites</a>
              </router-link>
            </ul>
          </router-link>
          <router-link tag="li" to="/contact" class="nav__list-item">
            <a href="#">contact</a>
          </router-link>
          <router-link tag="li" to="/case-studies" class="nav__list-item">
            <a href="#">case studies</a>
          </router-link>
          <router-link
            v-if="auth.currentUser"
            tag="li"
            :to="{ name: 'Dashboard' }"
            class="nav__list-item"
          >
            <a href="#">dashboard</a>
          </router-link>
        </ul>
      </div>
    </nav>

    <div class="empty-space" v-if="this.$route.name === `Case Study`"></div>
  </div>
</template>

<script>
import { auth, messaging } from "../firebase-config";
import { mapGetters } from "vuex";
import {
  subscribeToPushNotification,
  unsubscribeFromPushNotification
} from "../registerServiceWorker";
export default {
  data() {
    return {
      open: false,
      disabled: false
    };
  },
  computed: {
    auth() {
      return auth;
    },
    supportsMessaging() {
      return messaging ? true : false;
    },
    ...mapGetters(["notificationStatus"])
  },
  methods: {
    async setNotificationStatus() {
      navigator.serviceWorker.ready.then(async registration => {
        this.disabled = true;
        try {
          if (this.notificationStatus) {
            await unsubscribeFromPushNotification(registration);
          } else {
            await subscribeToPushNotification(registration);
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.disabled = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "bootstrap";

#navigation-menu {
  position: fixed;
  z-index: 100;
}

.empty-space {
  height: 100px;
  background: $dark;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  // z-index: 99998;
}

.logo-wrap {
  position: fixed;
  display: inline-block;
  left: 30px;
  top: 44px;
  cursor: pointer;
  z-index: 99999;

  @include media-breakpoint-up(xl) {
    left: 50px;
  }

  svg {
    path {
      transform: translateX(-100vw);
      opacity: 0;
      animation: slide 500ms cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;

      @keyframes slide {
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }

      @include media-breakpoint-down(md) {
        display: none;

        &.logomark {
          display: block;
        }
      }
    }
  }

  &:hover {
    .logomark {
      fill: $primary;
    }
  }

  a {
    cursor: pointer;
  }

  svg {
    height: 30px;
    width: auto;
    fill: #fff;
    cursor: pointer;

    .logomark {
      transition: 0.2s fill linear;
    }
  }
}

.cd-header {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(20, 21, 26, 0.96);
  width: 100%;
  z-index: 2002;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  height: 100px;
  background: transparent;
  box-shadow: none;
  transition: all 300ms linear;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
}

.cd-header.is-fixed {
  position: fixed;
  top: -100px;
  background-color: rgba(20, 21, 26, 0.96);
  transition: transform 0.3s;
}

.cd-header.is-visible {
  transform: translate3d(0, 100%, 0);
}

.cd-header.menu-is-open {
  background-color: rgba(21, 21, 21, 0);
}

.push-notification {
  position: fixed;
  padding: 0;
  left: calc(100vw - 110px);
  top: 40px;
  color: white;
  cursor: pointer;
  z-index: 99999;
  display: inline-block;
  transition: all 0.3s ease-out;

  &.active {
    svg {
      fill: $primary;
    }
  }

  svg {
    height: 30px;
    width: 30px;
    fill: whitesmoke;
  }

  @include media-breakpoint-up(xl) {
    left: calc(100vw - 150px);
  }
}

.navbar-wrap {
  position: fixed;
  left: calc(100vw - 60px);
  top: 44px;
  cursor: pointer;
  z-index: 99999;
  display: inline-block;
  transition: all 0.3s ease-out;

  @include media-breakpoint-up(xl) {
    left: calc(100vw - 100px);
  }
}

//menu-icon positioning and animation
.menu-icon {
  height: 30px;
  width: 30px;
  position: relative;
  z-index: 2;
  cursor: pointer;
  display: block;

  .menu-icon__line {
    height: 2px;
    width: 30px;
    display: block;
    background-color: #fff;
    margin-bottom: 7px;
    cursor: pointer;
    transition: background-color 0.5s ease;
    transition: transform 0.2s ease, background-color 0.5s ease;
    transition: transform 0.2s ease, background-color 0.5s ease;

    &.menu-icon__line-left {
      width: 16.5px;
      transition: all 200ms linear;
    }

    &.menu-icon__line-right {
      width: 16.5px;
      float: right;
      transition: all 200ms linear;
    }
  }

  &:hover {
    .menu-icon__line-left,
    .menu-icon__line-right {
      width: 30px;
      background-color: $primary;
    }
  }
}

.nav {
  position: fixed;
  z-index: 98;

  &:before,
  &:after {
    content: "";
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: -1;
    transition: transform cubic-bezier(0.77, 0, 0.175, 1) 0.8s;
    transform: translateY(-100%);
  }

  &:after {
    background: rgb(9, 9, 12);
    transition-delay: 0s;
  }

  &:before {
    transition-delay: 0.1s;
    background: $primary;
  }

  .nav__content {
    position: fixed;
    visibility: hidden;
    opacity: 0;
    top: 50%;
    margin-top: 40px;
    transform: translateY(-50%);
    transition: 0.5s ease;
    width: 100vw;
    text-align: center;
  }

  .curent-page-name-shadow {
    position: absolute;
    top: 50%;
    left: -100%;
    width: 300%;
    text-align: center;
    text-transform: lowercase;
    transform: translateY(-50%);
    font-family: "Poppins", sans-serif;
    font-size: 22vw;
    margin-top: 40px;
    font-weight: 900;
    color: #fff;
    opacity: 0;
    z-index: 1;
    transition: all 300ms linear;
  }

  .nav__list {
    position: relative;
    padding: 0;
    margin: 0;
    z-index: 2;
    list-style-type: none;

    .nav__list-item {
      position: relative;
      transition-delay: 0.8s;
      opacity: 0;
      text-align: center;
      color: #fff;
      font-family: "Poppins", sans-serif;
      font-size: 8vh;
      font-weight: 700;
      line-height: 1.05;
      letter-spacing: 3px;
      transform: translateY(100%);
      transition: opacity 0.2s ease, transform 0.3s ease;
      margin-top: 0;
      margin-bottom: 0;

      @media (max-width: 991px) {
        font-size: 5.5vh;

        a:hover:after,
        &.router-link-exact-active a:after {
          height: 10px;
        }
      }

      @for $i from 0 through 10 {
        &:nth-child(#{$i}) {
          transition-delay: #{0.4s + $i/10};
        }
      }

      &.router-link-exact-active a {
        color: rgba(255, 255, 255, 1);

        &:after {
          height: 20px;
          opacity: 1;
        }
      }

      a {
        position: relative;
        text-decoration: none;
        color: rgba(255, 255, 255, 0.6);
        overflow: hidden;
        padding-left: 5px;
        padding-right: 5px;
        z-index: 2;
        display: inline-block;
        transition: all 200ms linear;

        &:after {
          position: absolute;
          content: "";
          bottom: 2px;
          left: 0;
          width: 100%;
          height: 0;
          opacity: 0;
          margin-top: 3px;
          background-color: $primary;
          z-index: -1;
          transition: all 200ms linear;
        }

        &:hover {
          color: rgba(255, 255, 255, 1);
        }

        &:hover:after {
          height: 20px;
          opacity: 1;
        }
      }

      //sub-links
      .sub-links {
        position: relative;
        margin: 20px 0;
        transition: all 200ms linear;

        li {
          text-align: center;
          font-weight: 400;
          font-size: 15px;
          list-style-type: none;
          margin: 15px 0;

          &.router-link-exact-active a {
            color: $primary;

            &:hover::after {
              display: none;
            }
          }
        }
      }
    }
  }
}

//active state
.nav-active {
  .nav__content {
    visibility: visible;
    opacity: 1;
  }

  .cd-header.is-fixed {
    transform: translate3d(0, 100%, 0);
  }

  .menu-icon__line {
    background-color: #fff;
    transform: translate(0px, 0px) rotate(-45deg);
  }

  .menu-icon__line-left {
    background-color: $primary;
    width: 15px;
    transform: translate(2px, 4px) rotate(45deg);
  }

  .menu-icon__line-right {
    background-color: $primary;
    width: 15px;
    float: right;
    transform: translate(-3px, -3.5px) rotate(45deg);
  }

  .menu-icon:hover {
    .menu-icon__line-left,
    .menu-icon__line-right {
      width: 15px;
    }
  }

  .nav {
    visibility: visible;

    &:before,
    &:after {
      transform: translateY(0%);
    }

    &:after {
      transition-delay: 0.1s;
    }

    &:before {
      transition-delay: 0s;
    }

    .curent-page-name-shadow {
      margin-top: -25px;
      opacity: 0.08;
      transition-delay: 0.5s;

      @media (max-width: 991px) {
        margin-top: -10px;
      }

      @media (max-width: 767px) {
        display: none;
      }
    }

    .nav__list-item {
      opacity: 1;
      transform: translateY(0%);
      transition: opacity 0.3s ease, transform 0.3s ease, color 0.3s ease;
    }
  }
}
</style>
